<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Projects") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card v-blur="blur">
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Projects List") }}</h4>
          </div>
        </md-card-header>
        <projects-table
          :projects="projects"
          @showProjectEditor="showProjectEditor"
        />
      </md-card>
      <project-form
        v-if="editingProject"
        :project="projectToEdit"
        :project-position="projectPosition"
        @closeProjectEditor="closeProjectEditor"
        @showNoPilotEmailsWarning="showNoPilotEmailsWarning"
      />
      <no-pilot-emails-warning
        v-if="noPilotEmailsWarningIsDisplayed"
        @closeNoPilotEmailsWarning="closeNoPilotEmailsWarning"
      />
    </div>
  </div>
</template>

<script>
import { mapMultiRowFields } from "vuex-map-fields";
import { mask } from "vue-the-mask";
import { router } from "@/main";
import swal from "sweetalert2";
import { USER_TYPE } from "@/const.js";
import ProjectForm from "@/pages/Dashboard/Settings/Projects/ProjectForm.vue";
import ProjectsTable from "@/pages/Dashboard/Settings/Projects/ProjectsTable.vue";
import NoPilotEmailsWarning from "@/pages/Dashboard/Settings/Projects/NoPilotEmailsWarning.vue";

export default {
  directives: { mask },
  components: {
    NoPilotEmailsWarning,
    ProjectsTable,
    ProjectForm
  },
  data() {
    return {
      USER_TYPE,
      responsive: false,
      editingProject: false,
      projectPosition: 0,
      projectToEdit: null,
      noPilotEmailsWarningIsDisplayed: false
    };
  },
  computed: {
    blur: function() {
      return this.editingProject;
    },
    ...mapMultiRowFields("setting", ["projects"])
  },
  methods: {
    onResponsiveInverted() {
      this.responsive = window.innerWidth < 768;
    },
    showProjectEditor(position) {
      this.projectPosition = position;
      this.projectToEdit = this.projects[position];
      this.editingProject = true;
    },
    closeProjectEditor() {
      this.editingProject = false;
    },
    showNoPilotEmailsWarning() {
      this.editingProject = false;
      this.noPilotEmailsWarningIsDisplayed = true;
    },
    closeNoPilotEmailsWarning() {
      this.noPilotEmailsWarningIsDisplayed = false;
    }
  },
  beforeMount() {
    if (
      this.$store.state.auth.usertype === USER_TYPE.PILOT ||
      this.$store.state.auth.usertype === USER_TYPE.FREE ||
      this.$store.state.auth.usertype === USER_TYPE.PRO ||
      this.$store.state.auth.usertype === USER_TYPE.MAAC
    ) {
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t("Only administrator can access Project Setting page!"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/dashboard");
        });
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>
